module.exports = __webpack_public_path__ + "img/p2-3.da36cdff.png";